/*
  used in snippets/ccustomCartRecommendationsLiquid.liquid

  Hakee ostoskorin "Muut ostivat" -suositukset Shopifyn suositus-endpointista ja
  renderöi sectionin ccustom-cart-recommendations sisällön paikalleen.

  Ostoskori renderöidään uudelleen jokaisen muutoksen jälkeen, joten elementti
  luodaan uudelleen ja suositukset päivittyvät. Samat URL:t haetaan vain kerran
  sivulatausta kohden.
*/

if (!customElements.get('ccustom-cart-recs')) {
  customElements.define(
    'ccustom-cart-recs',
    class CcustomCartRecs extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url || this.dataset.loaded === 'true') return;

        window.ccustomCartRecsCache = window.ccustomCartRecsCache || new Map();
        const cache = window.ccustomCartRecsCache;

        if (cache.has(url)) {
          this.render(cache.get(url));
          return;
        }

        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            cache.set(url, text);
            this.render(text);
          })
          .catch(() => {
            // Suositukset ovat lisäominaisuus: virhetilanteessa ei näytetä mitään
          });
      }

      render(text) {
        const inner = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.ccustom-cart-recs__inner');

        if (!inner) return;

        this.innerHTML = inner.outerHTML;
        this.dataset.loaded = 'true';
        this.setupNav();
      }

      /* Nuolinapit: kosketuslaitteilla riittää vaakavieritys, hiirellä ei */
      setupNav() {
        const track = this.querySelector('.ccustom-cart-recs__track');
        const nav = this.querySelector('.ccustom-cart-recs__nav');
        if (!track || !nav) return;

        const prev = nav.querySelector('[data-direction="prev"]');
        const next = nav.querySelector('[data-direction="next"]');

        const step = () => {
          const item = track.querySelector('.ccustom-cart-recs__item');
          if (!item) return track.clientWidth;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return item.getBoundingClientRect().width + gap;
        };

        const update = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          nav.hidden = maxScroll <= 1;
          prev.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= maxScroll - 1;
        };

        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', update, { passive: true });

        if ('ResizeObserver' in window) {
          this.navObserver = new ResizeObserver(update);
          this.navObserver.observe(track);
        }

        update();
      }

      disconnectedCallback() {
        if (this.navObserver) this.navObserver.disconnect();
      }
    }
  );
}
